import dayjs from "dayjs";


/*
Dado um número de versão MAJOR.MINOR.PATCH, incremente a:

versão Maior(MAJOR): quando fizer mudanças incompatíveis na API,
versão Menor(MINOR): quando adicionar funcionalidades mantendo compatibilidade, e
versão de Correção(PATCH): quando corrigir falhas mantendo compatibilidade.
 */
export const APP_VERSION = "1.0.0";

export const ringSizeArray = Array.from({ length: 25 }, (_, i) => {
    const value = i + 10;
    return {
        value,
        label: "Número " + value,
    };
});

export const metalList = [
    { value: 1, label: 'Ouro 18K' },
    { value: 2, label: 'Ouro 10K' },
    { value: 3, label: 'Prata 950' },
];

export const materials = {
    1: { name: 'Ouro 18K', color: '#D4AF37' },
    2: { name: 'Ouro 10K', color: '#D4B878' },
    3: { name: 'Prata 950', color: '#A6A6A6' }
};

export const currentMonthDayOne = dayjs().startOf('month');

export const currentDate = dayjs();

export function buildDefaultDeliveryDate(businessDays = 3, workdays = [1, 2, 3, 4, 5]) {
    const allowed = workdays.length ? workdays : [1, 2, 3, 4, 5];
    const days = Number(businessDays) > 0 ? Number(businessDays) : 3;
    let date = dayjs();
    let added = 0;

    while (added < days) {
        date = date.add(1, 'day');
        if (allowed.includes(date.day())) {
            added += 1;
        }
    }

    while (!allowed.includes(date.day())) {
        date = date.add(1, 'day');
    }

    return date;
}

export const defaultDeliveryDate = buildDefaultDeliveryDate();

export const metalNames = {
    1: 'Ouro 18K',
    2: 'Ouro 10K',
    3: 'Prata 950'
};

// Mapeamento de passos de produção
export const stepNames = {
    0: 'Triagem',
    1: 'Fundição',
    2: 'Usinagem',
    3: 'Montagem',
    4: 'Polimento',
    5: 'Banho',
    6: 'Laser',
    7: 'Fechamento'
};
